export default __webpack_public_path__ + "8fb5014b39e5c6ef426eda32f62da064.png";